module.exports = __webpack_public_path__ + "../static/media/5632-font.83d3c1b3.ttf";